import { Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const EmptyStateContainer = styled(Stack)(() => ({
  alignItems: 'center',
  justifyContent: 'center',
  padding: '3rem 1.5rem',
  textAlign: 'center',
  minHeight: '300px',
}));

export const EmptyStateTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: '1.125rem',
  color: theme.palette.grey[900],
  marginTop: '1.5rem',
  marginBottom: '0.5rem',
}));

export const EmptyStateText = styled(Typography)(({ theme }) => ({
  fontSize: '0.875rem',
  color: theme.palette.grey[600],
  maxWidth: '400px',
  lineHeight: 1.6,
}));
